import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MetricsPort } from '@service/preclinical/metrics.port';
import { OrderMetricsService } from '@infra-shared/services/metrics/order-metrics.service';
import { IngestedOrdersMetrics } from '@model/ingested-order/ingested-order.model';
import { OrderStatus } from '@infra-services/ingested-orders/api/ingested-orders-api.interface';

@Injectable({
  providedIn: 'root'
})
export class MetricsAdapter implements MetricsPort {
  private readonly metricsService = inject(OrderMetricsService);

  getMetrics(status?: OrderStatus): Observable<IngestedOrdersMetrics> {
    return this.metricsService.getMetrics(status);
  }

  getMetricsStream(
    status?: OrderStatus,
    intervalMs?: number
  ): Observable<IngestedOrdersMetrics> {
    return this.metricsService.getMetricsStream(status, intervalMs);
  }
}
